import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogModel } from '../../../core/_models/confirm-dialog.model';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
})
export class MessageComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {}

  
}
